import React, { Fragment } from "react";
import { useParams } from "react-router-dom";
//
import { useForm } from "react-hook-form";
//
import { useQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
//
import Snackbar from "@material-ui/core/Snackbar";
import Typography from "@material-ui/core/Typography";
import DialogForm from "components/dialogForm";
import FormField from "components/formField";

export const CREATE_COOPERATIVE = gql`
  mutation CreateCooperative($input: CreateCooperativeInput!) {
    createCooperative(input: $input) {
      code
      success
      message
    }
  }
`;

export default function() {
  const { id } = useParams();

  const [
    createCooperative,
    { data: mutationData, loading: mutationLoading, error: mutationError }
  ] = useMutation(CREATE_COOPERATIVE);

  const { register, control, handleSubmit, formState, errors } = useForm({
    //mode: "onChange"
  });

  const onSubmit = data => {    
    const { businessName } = data;

    const variables = {
      input: {
        businessName 
      }
    };    

    createCooperative({
      variables
    });
  };

  return (
    <Fragment>
      <Snackbar
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        open={mutationLoading}
        message={"Creazione della società avviata con successo."}
      />
      <Snackbar
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        open={Boolean(mutationError)}
        message={"Si è verificato un errore nella creazione della società"}
      />
      <DialogForm
        id="create-cooperative"
        title={
          `Creazione Nuova Società`
        }
        subTitle={`La seguente procedura avvierà la creazione di una nuova società.`}
        buttonTitle='Crea società'
        formState={formState}
        onSubmit={handleSubmit(onSubmit)}
      >
          { true && <FormField
            id="businessName"
            name="businessName"
            label="Ragione sociale"
            type="text"
            //inputRef={register({ required: "Inserisci il codice." })}
            control={control}
            error={errors.password}
          />}             
      </DialogForm>
    </Fragment>
  );
}
